/* eslint-disable @typescript-eslint/naming-convention */
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getProductList,
  putUpdateProductStatusApi,
  type GetProductListParamsType,
  getVendorCountApi,
  getProductVendorFeatureFlagApi,
  getProductVendorCounts,
} from 'features/Product/services/product'

import { PutUpdateProductStatusPayloadType } from 'features/Product/@types/ProductAdd'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME_PRODUCT = 'product'

export const fetchProductList = createAsyncThunk(
  `${SLICE_NAME_PRODUCT}/fetchProductList`,
  async (query: GetProductListParamsType, { rejectWithValue }) => {
    try {
      const response = await getProductList(query)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const updateProductStatus = createAsyncThunk(
  `${SLICE_NAME_PRODUCT}/updateProductStatus`,
  async (
    params: { productId: number; payload: PutUpdateProductStatusPayloadType },
    { rejectWithValue },
  ) => {
    try {
      const response = await putUpdateProductStatusApi(params.productId, params.payload)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchVendorCount = createAsyncThunk(
  `${SLICE_NAME_PRODUCT}/fetchVendorCount`,
  async (productId: number) => {
    try {
      const {
        data: { data },
      } = await getVendorCountApi(productId)
      return { ...data, isError: false }
    } catch (error) {
      callErrorMsg(error)
      return { vendorCount: 0, isError: true }
    }
  },
)

export const fetchProductVendorsCount = createAsyncThunk(
  `${SLICE_NAME_PRODUCT}/fetchProductVendorsCount`,
  async (lcoationIds: number[]) => {
    try {
      const { data } = await getProductVendorCounts(lcoationIds?.join(','))
      return data?.data || []
    } catch (error) {
      callErrorMsg(error)
      return []
    }
  },
)

export const fetchProductVendorFeatureFlag = createAsyncThunk(
  `${SLICE_NAME_PRODUCT}/fetchProductVendorFeatureFlag`,
  async () => {
    try {
      const { data } = await getProductVendorFeatureFlagApi()
      return data?.data?.FF_ENABLE_VENDOR_CATALOG_MIGRATION_ALLOYDB
    } catch (error) {
      callErrorMsg(error)
      return 'false'
    }
  },
)
